export const ADD_TO_CART = 'ADD_TO_CART';
export const UPDATE_QUANTITY = 'UPDATE_QUANTITY';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const TOGGLE_CART_SIDEBAR = 'TOGGLE_CART_SIDEBAR';
export const CLEAR_CART = "CLEAR_CART";

export const addToCart = (item) => ({
  type: ADD_TO_CART,
  payload: item,
});

export const updateQuantity = (id, size, color, quantity) => ({
  type: UPDATE_QUANTITY,
  payload: { id, size, color, quantity },
});

export const removeFromCart = (id, size, color) => ({
  type: REMOVE_FROM_CART,
  payload: { id, size, color },
});

export const toggleCartSidebar  = () => ({
  type: TOGGLE_CART_SIDEBAR,
});
export const clearCart = () => ({
  type: CLEAR_CART,
});